import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../../core/services/auth/auth.service";
import { CompanyAddEditDialogComponent } from "../company-add-edit-dialog/company-add-edit-dialog.component";
import { CompanyDeleteDialogComponent } from "../company-delete-dialog/company-delete-dialog.component";
import { Const } from "../../core/data/models/const";
import { GetLoginUserResponse } from "../../core/data/models/get-login-user-response";
import { SiteInfo } from "../../core/data/models/get-site-info";
import { LoginUser } from "../../core/data/models/login-user";
import { LoginUserSite } from "../../core/data/models/login-user-site";
import { LoginUserSiteCompany } from "../../core/data/models/login-user-site-company";
import { CompanyModel } from "../site-management/site-management.component";
import { CompanyApi } from "src/app/core/api/company.api";
import { SitesApi } from "src/app/core/api/sites.api";
import { AlertMessage } from "src/app/core/constants/messages/alert-message";
import { LoginUserService } from "src/app/core/services/login-user.service";

@Component({
  selector: "app-company-management",
  templateUrl: "./company-management.component.html",
  styleUrls: ["./company-management.component.scss"],
})
export class CompanyManagementComponent implements OnInit {
  loginUser: LoginUser = Const.loginUser;
  idToken: string;
  getLoginUserUrl: string;

  // テーブル生成用
  displayedColumns: string[];
  companyData: CompanyModel[];
  filterdCompanyData: CompanyModel[];

  searchKeyString: string = "";
  searchKeyChanged: Subject<string> = new Subject<string>();

  // フラグ類
  getCompanyDataFinished: boolean;
  mjitUserFlag = false;
  adminUserFlag = false;

  constructor(
    private router: Router,
    public auth: AuthService,
    private route: ActivatedRoute,
    public dialog: MatDialog,

    private loginUserService: LoginUserService,

    private companyApi: CompanyApi,
    private sitesApi: SitesApi
  ) {
    localStorage.setItem("path", router.url);
  }

  async ngOnInit() {
    await this.loginUserService.getLoginUserInfo();

    this.companyData = [];
    this.loginUser = Const.loginUser;
    this.mjitUserFlag = Const.mjitUser;
    this.adminUserFlag = Const.adminUser;
    this.searchKeyChanged
      .debounceTime(300) // wait 300ms after the last event before emitting last event
      .subscribe((str) => {
        this.searchKeyString = str;
        this.filterResult();
      });

    this.getCompanyData();
  }

  getCompanyData() {
    this.getCompanyDataFinished = false;
    this.filterdCompanyData = [];
    try {
      this.companyApi.getCompany("all").subscribe((res) => {
        let jsonStr = JSON.stringify(res);
        let jsonObj = JSON.parse(jsonStr);
        this.companyData = jsonObj.result.companies;
        this.filterdCompanyData = this.companyData;
        this.displayedColumns = [
          "companyName",
          "createdBy",
          "createdAt",
          "updatedBy",
          "updatedAt",
          "editButton",
          "deleteButton",
        ];
        this.getCompanyDataFinished = true;
      });
    } catch (error) {
      console.error(error);
      alert(AlertMessage.UNEXPECTED_ERROR_MESSAGE);
    }
  }

  onClickAddCompany() {
    const dialogRef = this.dialog.open(CompanyAddEditDialogComponent, {
      width: "650px",
      data: false,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === "close") {
        this.getCompanyData();
      }
    });
  }

  onClickCompanyEdit(company: CompanyModel) {
    const dialogRef = this.dialog.open(CompanyAddEditDialogComponent, {
      width: "650px",
      data: true,
    });
    dialogRef.componentInstance.company = company;
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === "close") {
        this.getCompanyData();
      }
    });
  }

  onClickCompanyDelete(company: CompanyModel) {
    const dialogRef = this.dialog.open(CompanyDeleteDialogComponent, {
      width: "650px",
      data: company,
    });
    dialogRef.afterClosed().subscribe((makeResult) => {
      if (makeResult === "close") {
        this.getCompanyData();
        this.getAllSiteData();
      }
    });
  }
  // 施設情報の取得（UserType:0はシステム管理者として登録されている施設を全件取得する。）
  getAllSiteData() {
    try {
      Const.siteInfo.splice(0);
      this.sitesApi.getSitesInfo("all").subscribe((res) => {
        const jsonStr = JSON.stringify(res);
        const jsonObj = JSON.parse(jsonStr);
        for (const site of jsonObj.result.sites as SiteInfo[]) {
          const siteItem = new LoginUserSite();
          siteItem.id = site.id;
          siteItem.name = site.name;
          siteItem.address = site.address;
          siteItem.updated_at = site.updated_at;
          siteItem.created_at = site.created_at;
          siteItem.company = new LoginUserSiteCompany();
          siteItem.company.id = site.company_id;
          siteItem.company.name = site.company_name;
          Const.siteInfo.push(siteItem);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  filterResult() {
    if (this.searchKeyString === "") {
      this.filterdCompanyData = this.companyData;
      return;
    }
    this.filterdCompanyData = this.companyData.filter((item) =>
      item.name.includes(this.searchKeyString)
    );
  }

  search(text: string) {
    this.searchKeyChanged.next(text);
  }
}
